var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLossIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24518 10.3379C6.86915 11.0456 5.85503 11.0456 5.479 10.3379L0.766937 1.4692C0.413054 0.803143 0.895803 -1.12149e-06 1.65003 -1.05556e-06L11.0742 -2.31673e-07C11.8284 -1.65736e-07 12.3111 0.803145 11.9572 1.4692L7.24518 10.3379Z",
    fill: "#FF544F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLossIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/loss icon.190905a3dc207fd4b73098ddec26de80.svg";